export function sitesUpdate (payload) {
    return async dispatch => {

        dispatch({
            type: 'SITES_UPDATE',
            status: 'OK',
            payload: payload
        })

    }
}